// Thin, SSR-safe wrapper around the GA4 gtag for the AI Custom Blocks landing.
// The site loads gtag globally (see gatsby-ssr.js), so we only fire events when
// it is actually present. Param shape (event_category / event_label) matches the
// existing form tracking so events stay consistent in GA.
//
// Usage:
//   trackEvent("Download Plugin", { category: "Plugin", label: "Hero" });
export const trackEvent = (action, { category, label, ...rest } = {}) => {
  if (!action) return;
  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "function") return;

  const params = { ...rest };
  if (category) params.event_category = category;
  if (label) params.event_label = label;

  window.gtag("event", action, params);
};

export default trackEvent;
